import { Directive } from '@angular/core';

@Directive({
  selector: '[jbDialogActionsBottom]',
})
export class DialogActionsBottomDirective {}
